import fetch from './fetch';
import { POST } from './constants';

const post = params => {
  params.method = POST;
  return fetch(params);
};

export default post;



// WEBPACK FOOTER //
// ./src/api/post.js